import React, { useState } from 'react';
import {
  FooterContainer,
  FooterGrid,
  FooterColumn,
  ColumnTitle,
  LinkList,
  LinkItem,
  Link,
  NewsletterBox,
  EmailForm,
  EmailInput,
  SubmitBtn,
  NewsletterText,
  FooterSeparator,
  FooterBottom,
  FooterLogo,
  LogoImage,
  FooterLinks,
  FooterLink,
  SocialIcons,
  SocialIcon
} from './Footer.styles';
import logo from "../../assets/olasoftlogo_whit.png";

const Footer = () => {
  const [email, setEmail] = useState('');
  const [hoveredLink, setHoveredLink] = useState(null);
  const [hoveredSocial, setHoveredSocial] = useState(null);

  const handleSubmit = () => {
    console.log('Email submitted:', email);
    setEmail('');
  };

  const productLinks = [
    'Employee database',
    'Payroll',
    'Absences',
    'Time tracking',
    'Shift planner',
    'Recruiting',
  ];

  const informationLinks = ['FAQ', 'Blog', 'Support'];
  const companyLinks = ['About us', 'Careers', 'Contact us', 'Lift Media'];
  const footerBottomLinks = ['Terms', 'Privacy', 'Cookies'];
  const socialLinks = [
    { icon: 'in', url: '#' },
    { icon: 'f', url: '#' },
    { icon: '𝕏', url: '#' },
  ];

  return (
    <FooterContainer>
      <FooterGrid>
        {/* Product Column */}
        <FooterColumn>
          <ColumnTitle>Product</ColumnTitle>
          <LinkList>
            {productLinks.map((link, index) => (
              <LinkItem key={index}>
                <Link
                  href="#"
                  $isHovered={hoveredLink === `product-${index}`}
                  onMouseEnter={() => setHoveredLink(`product-${index}`)}
                  onMouseLeave={() => setHoveredLink(null)}
                >
                  {link}
                </Link>
              </LinkItem>
            ))}
          </LinkList>
        </FooterColumn>

        {/* Information Column */}
        <FooterColumn>
          <ColumnTitle>Information</ColumnTitle>
          <LinkList>
            {informationLinks.map((link, index) => (
              <LinkItem key={index}>
                <Link
                  href="#"
                  $isHovered={hoveredLink === `info-${index}`}
                  onMouseEnter={() => setHoveredLink(`info-${index}`)}
                  onMouseLeave={() => setHoveredLink(null)}
                >
                  {link}
                </Link>
              </LinkItem>
            ))}
          </LinkList>
        </FooterColumn>

        {/* Company Column */}
        <FooterColumn>
          <ColumnTitle>Company</ColumnTitle>
          <LinkList>
            {companyLinks.map((link, index) => (
              <LinkItem key={index}>
                <Link
                  href="#"
                  $isHovered={hoveredLink === `company-${index}`}
                  onMouseEnter={() => setHoveredLink(`company-${index}`)}
                  onMouseLeave={() => setHoveredLink(null)}
                >
                  {link}
                </Link>
              </LinkItem>
            ))}
          </LinkList>
        </FooterColumn>

        {/* Newsletter Column */}
        <FooterColumn>
          <NewsletterBox>
            <ColumnTitle>S'abonner</ColumnTitle>
            <EmailForm>
              <EmailInput
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <SubmitBtn type="button" onClick={handleSubmit}>
                →
              </SubmitBtn>
            </EmailForm>
            <NewsletterText>
              Loorem, we are Lift Media. Our goal is to translate the positive
              effects from revolutionizing how companies engage with their clients
              & their team.
            </NewsletterText>
          </NewsletterBox>
        </FooterColumn>
      </FooterGrid>

      <FooterSeparator />

      <FooterBottom>
        {/* Logo */}
        <FooterLogo>
          <LogoImage src={logo} alt="LaSoft Logo" />
        </FooterLogo>

        {/* Footer Links */}
        <FooterLinks>
          {footerBottomLinks.map((link, index) => (
            <FooterLink
              key={index}
              href="#"
              $isHovered={hoveredLink === `bottom-${index}`}
              onMouseEnter={() => setHoveredLink(`bottom-${index}`)}
              onMouseLeave={() => setHoveredLink(null)}
            >
              {link}
            </FooterLink>
          ))}
        </FooterLinks>

        {/* Social Icons */}
        <SocialIcons>
          {socialLinks.map((social, index) => (
            <SocialIcon
              key={index}
              href={social.url}
              $isHovered={hoveredSocial === index}
              onMouseEnter={() => setHoveredSocial(index)}
              onMouseLeave={() => setHoveredSocial(null)}
            >
              {social.icon}
            </SocialIcon>
          ))}
        </SocialIcons>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;